
<div class="grid">
    <p-toast position="top-center" key="tc"></p-toast>
    <div class="col-12">
        <form>
            <p-card [header]="'ADD_DRIVER' | translate">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid" [formGroup]="driverForm">
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500">{{
                            "FIRST_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="firstname"
                            [placeholder]="'FIRST_NAME' | translate"
                            pInputText
                            formControlName="firstName"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="surname" class="text-sm text-500">{{
                            "LAST_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="surname"
                            [placeholder]="'LAST_NAME' | translate"
                            pInputText
                            formControlName="surname"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="dob" class="text-sm text-500">{{
                            "DATE_OF_BIRTH" | translate
                        }}</label>
                        <p-calendar
                            [disabledDates]="dateValidator.invalidDates"
                            [maxDate]="dateValidator.maxDate"
                            #dob
                            [placeholder]="'DATE_OF_BIRTH' | translate"
                            formControlName="dateOfBirth"
                        >
                        </p-calendar>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'en'"
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "GENDER" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            #gender
                            formControlName="gender"
                            optionLabel="name"
                            optionValue="value"
                            [options]="genderTypes"
                            placeholder="Select Gender Type"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="selectedLanguage === 'pt'"
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "GENDER" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            #gender
                            formControlName="gender"
                            optionLabel="name"
                            optionValue="value"
                            [options]="translatedGenderTypes"
                            placeholder="Selecione o gênero"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            idTypes &&
                            idTypes.length > 0 &&
                            selectedLanguage === 'pt'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "SELECT_ID_TYPE" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            #gender
                            formControlName="identificationType"
                            optionLabel="name"
                            optionValue="value"
                            [options]="idTypes"
                            placeholder="Selecionar tipo de identificação"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            idTypes &&
                            idTypes.length > 0 &&
                            selectedLanguage === 'en'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "SELECT_ID_TYPE" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            #gender
                            formControlName="identificationType"
                            optionLabel="name"
                            optionValue="value"
                            [options]="idTypes"
                            placeholder="Select Identification Type"
                        >
                        </p-dropdown>
                    </div>

                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            countries &&
                            countries.length > 0 &&
                            selectedLanguage === 'en'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "ENTER_COUNTRY_OF_ISSUE" | translate
                        }}</label>
                        <p-dropdown
                            [filter]="true"
                            filterBy="name"
                            formControlName="countryOfIDIssue"
                            optionLabel="name"
                            optionValue="name"
                            [options]="countries"
                            placeholder="Country Of ID Issue"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            countries &&
                            countries.length > 0 &&
                            selectedLanguage === 'pt'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "ENTER_COUNTRY_OF_ISSUE" | translate
                        }}</label>
                        <p-dropdown
                            [filter]="true"
                            filterBy="name"
                            formControlName="countryOfIDIssue"
                            optionLabel="name"
                            optionValue="name"
                            [options]="countries"
                            placeholder="Digite o País de Emissão"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            countries &&
                            countries.length > 0 &&
                            selectedLanguage === 'en'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "Nationality" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            [filter]="true"
                            filterBy="name"
                            formControlName="nationality"
                            optionLabel="name"
                            optionValue="name"
                            [options]="countries"
                            placeholder="Select Your Nationality"
                        >
                        </p-dropdown>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        *ngIf="
                            countries &&
                            countries.length > 0 &&
                            selectedLanguage === 'pt'
                        "
                    >
                        <label htmlFor="gender" class="text-sm text-500">{{
                            "Nationality" | translate
                        }}</label>
                        <p-dropdown
                            (onChange)="onGenderChange($event)"
                            [filter]="true"
                            filterBy="name"
                            formControlName="nationality"
                            optionLabel="name"
                            optionValue="name"
                            [options]="countries"
                            placeholder="Selecione sua nacionalidade"
                        >
                        </p-dropdown>
                    </div>

                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="id" class="text-sm text-500">{{
                            "Identification number" | translate
                        }}</label>
                        <input
                            type="text"
                            id="id"
                            [placeholder]="
                                'National Identification Number / Passport Number'
                                    | translate
                            "
                            pInputText
                            formControlName="nationalIdentification"
                        />
                    </div>

                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="vrn" class="text-sm text-500">{{
                            "Confirm Identification Number" | translate
                        }}</label>
                        <input
                            type="text"
                            id="vrn"
                            (keyup)="onConfirmIDKeyUp()"
                            [placeholder]="
                                'Confirm Identification Number' | translate
                            "
                            pInputText
                            formControlName="confirmNationalIdentification"
                        />
                        <small *ngIf="showIdMisMatchMessage" style="color: red"
                            >Your ID numbers do not match!</small
                        >
                    </div>
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            [label]="'Back' | translate"
                            severity="secondary"
                            routerLink="/home/drivers"
                        />
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            [label]="'Clear' | translate"
                            severity="danger"
                        />

                        <button
                            icon="pi pi-save"
                            [label]="'Save' | translate"
                            severity="success"
                            pTooltip="'ADD_DRIVER' | translate"
                            [disabled]="!driverForm.valid"
                            (click)="onDriverSubmit()"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
